import type { ApolloError } from '@apollo/client';
import type { NextRouter } from 'next/router';

import type { TaskTypeName } from '@savvy/constants/generated/gql-enums';
import type { XRouter } from '@savvy/deprecated-shared/hooks/use-router';
import { LOGIN_CONTEXT_PARAM } from '@savvy/deprecated-shared/utils/routing';
import { toast } from '@savvy/deprecated-shared/x-components/x-toast';

const INVITE_AUTH_SCHEME = 'Invite';
const RESET_PASSWORD_AUTH_SCHEME = 'ResetPassword';

export function getAuthHeader(router: XRouter | NextRouter) {
  const resetPasswordToken = router.query['resetPasswordToken'];
  const createPasswordToken = router.query['createPasswordToken'];
  const inviteToken = router.query['inviteToken'];
  const loginContext = getLoginContext(router);
  if (resetPasswordToken && typeof resetPasswordToken === 'string') {
    return `${RESET_PASSWORD_AUTH_SCHEME} ${resetPasswordToken}`;
  } else if (createPasswordToken && typeof createPasswordToken === 'string') {
    return `${RESET_PASSWORD_AUTH_SCHEME} ${createPasswordToken}`;
  } else if (inviteToken && typeof inviteToken === 'string') {
    return `${INVITE_AUTH_SCHEME} ${inviteToken}`;
  } else if (loginContext && typeof loginContext === 'string') {
    return `${INVITE_AUTH_SCHEME} ${loginContext.slice(loginContext.indexOf('_') + 1)}`;
  }

  return '';
}

export function getLoginContext(router: XRouter | NextRouter) {
  return router.query[LOGIN_CONTEXT_PARAM];
}

export function handleInviteErrors(
  replace: (url: string) => void,
  inviteToken: string | null | undefined,
  taskType: TaskTypeName,
  error?: ApolloError,
) {
  if (error) {
    const errorMessage = error.graphQLErrors[0]?.message;
    const returnToLoginUrl = `/login?returnUrl=${window.encodeURIComponent(
      window.location.pathname + window.location.search,
    )}`;
    if (errorMessage?.includes('already activated')) {
      toast.error('Please log in with your existing Savvy account!');
      replace(returnToLoginUrl);
    } else if (errorMessage?.includes('expired')) {
      replace(`/refresh-invite-token-dialog?taskType=${taskType}&inviteToken=${inviteToken ?? ''}`);
    } else if (errorMessage?.includes('Bad Token')) {
      replace('/invalid-invite-token-dialog');
    } else if (errorMessage?.includes('is not a client')) {
      toast.error('Please log out of your Savvy account to view this page.');
    } else {
      replace(returnToLoginUrl);
    }
  }
}
